/* @flow */
import Link from 'components/Link.jsx';
import * as React from 'react';

import './styles/FooterNavItem.scss';

type Props = {
  // `?` for flow - https://github.com/facebook/flow/issues/1964
  children?: React.Node,
};

function FooterNavItem(props: Props) {
  const { children, ...others } = props;

  return (
    <Link {...others} target="_blank" weight="semibold" className="FooterNavItem">
      {children}
    </Link>
  );
}

export default FooterNavItem;
